import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const galleryItems = [{
  id: 1,
  src: "https://sacropan.it/wp-content/uploads/2026/04/image_5q17q2vu.jpg?v=hv9ve7hmvcc",
  alt: "Handpan resting on a mountain peak at sunrise",
  caption: "Vibrazioni all'Alba",
  spanClasses: "md:col-span-2 md:row-span-2"
}, {
  id: 2,
  src: "https://sacropan.it/wp-content/uploads/2026/04/207df0c8-f212-4faf-aea5-da96dad57915-scaled.jpeg?v=xkag1tqr7u",
  alt: "Rusted barbed wire against a mountain backdrop",
  caption: "Memorie di Ferro",
  spanClasses: "md:col-span-1 md:row-span-1"
}, {
  id: 3,
  src: "https://sacropan.it/wp-content/uploads/2026/04/fortesommoalto-scaled.jpg?v=0awq7ngjess",
  alt: "Panoramic view of the Vicentino mountain range",
  caption: "Orizzonti Sacri",
  spanClasses: "md:col-span-1 md:row-span-2"
}, {
  id: 4,
  src: "https://sacropan.it/wp-content/uploads/2026/04/3f69c257-3e33-42f3-aaac-98a106533396-scaled.jpeg?v=2x2hmroveoa",
  alt: "Close up of a stone trench wall from the Great War",
  caption: "Sentieri del Silenzio",
  spanClasses: "md:col-span-2 md:row-span-1"
}, {
  id: 5,
  src: "https://sacropan.it/wp-content/uploads/2026/04/image_xhjgqjcr.jpg?v=0royc6chptfd",
  alt: "Hands playing a handpan in a mountain setting",
  caption: "Preghiera di Metallo",
  spanClasses: "md:col-span-1 md:row-span-1"
}, {
  id: 6,
  src: "https://sacropan.it/wp-content/uploads/2026/04/20251231_154755-scaled.jpg?v=6zqwkxpwon",
  alt: "Shadow of an Alpini monument on the grass",
  caption: "L'Ombra del Ricordo",
  spanClasses: "md:col-span-1 md:row-span-1"
}, {
  id: 7,
  src: "https://sacropan.it/wp-content/uploads/2026/04/ossario-grappa-scaled.jpg?v=l2ww5yf49a",
  alt: "A foggy mountain path leading to a fortification",
  caption: "Passi nella Storia",
  spanClasses: "md:col-span-2 md:row-span-1"
}];
export default function VisualPoetry() {
  return <section data-section-id="221544" id="i-luoghi" className="bg-background text-foreground py-24 px-4 md:px-8 lg:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16 md:mb-24 max-w-2xl">
          <h2 className="font-default text-4xl md:text-6xl font-semibold tracking-tight mb-6 text-primary">
            I Luoghi del Sacro
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl leading-relaxed font-serif">Un viaggio visivo tra le vette del Vicentino, dove la pietra delle trincee è consumata, per onorare chi ha combattuto tra queste nuvole.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-2 md:gap-4 auto-rows-[250px] md:auto-rows-[300px] grid-flow-dense">
          {galleryItems.map((item, i) => <div key={item.id} data-index={i} className={`relative group overflow-hidden bg-muted shadow-md rounded-md ${item.spanClasses}`}>
              <img src={item.src} alt={item.alt} className="w-full h-full object-cover transition-transform duration-1000 ease-out group-hover:scale-110 grayscale-[30%] group-hover:grayscale-0" loading="lazy" />
              <div className="absolute inset-0 bg-background/60 opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-in-out flex items-center justify-center p-6 backdrop-blur-md">
                <span className="font-default text-2xl md:text-3xl text-foreground text-center translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-700 ease-out delay-100 italic">
                  {item.caption}
                </span>
              </div>
            </div>)}
        </div>

        <div className="mt-20 flex justify-center">
          <Button size="lg" variant="default" className="px-10 py-7 text-lg font-default bg-primary hover:bg-primary/90 text-primary-foreground transition-all duration-300 shadow-lg" asChild>
            <Link to="#">Esplora le Escursioni</Link>
          </Button>
        </div>
      </div>
    </section>;
}